import React from 'react';

export default function IfElse(props) {
	const condition = props.condition || false;
	const positive = props.then || null;
	const negative = props.else || null;

	if (condition) {
		if (typeof positive === 'function') {
			return positive();
		}
		return positive;
	}
	if (typeof negative === 'function') {
		return negative();
	}
	return negative;
}

const render = ({ children }) => {
	if (typeof children === 'function') {
		return <>{children()}</>;
	}

	return <>{children || null}</>;
};

function getConditionResult(condition) {
	const conditionResult = !!(typeof condition === 'function'
		? condition()
		: condition);

	return conditionResult;
}

export const Then = props => render(props);

export const Else = props => render(props);

export const If = ({ condition, children }) => {
	if (children == null) {
		return null;
	}

	return (
		<>
			{[]
				.concat(children)
				.find(
					c => (c.type !== Else) ^ !getConditionResult(condition)
				) || null}
		</>
	);
};

export const Case = props => render(props);

export const Default = props => render(props);

export function Switch({ children }) {
	// -- Inspired from react-router --

	// We use React.Children.forEach instead of React.Children.toArray().find()
	// here because toArray adds keys to all child elements and we do not want
	// to trigger an unmount/remount for two children <Case>s or <Default>s
	let matchingCase;
	let defaultCase;

	React.Children.forEach(children, child => {
		// not a valid react child, don't add it
		if (!React.isValidElement(child)) {
			return;
		}

		if (!matchingCase && child.type === Case) {
			const { condition } = child.props;

			const conditionResult = getConditionResult(condition);

			if (conditionResult) {
				matchingCase = child;
			} // else not matching condition, don't add it
		} else if (!defaultCase && child.type === Default) {
			defaultCase = child;
		} // else unknown type, don't add it
	});

	return matchingCase || defaultCase || null;
}
